<template>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div class="row dashboard-border">
        <div class="col-md-9 col-5 align-self-center" >
          <img src="../../assets/icons/user.png" height="30" width="30" class="mx-2"/>
          <span> User List</span>
          <!--<span class="tag is-medium is-dark is-light">User Count : {{userList.length}}</span>-->
        </div>
        <!--
        <div class="col-md-3 col-7 text-end d-flex">
          <input class="form-control me-1" type="search" placeholder="Search" aria-label="Search" v-model="searchText"
                 @input="filteredUser">
          <button class="btn" type="submit" style="background-color: #3c688f;color: #ffffff;">
            <font-awesome-icon icon="search" class="icon"/>
          </button>
        </div>
        -->
      </div>
      <div v-if="!isLoading" class="row mt-3 table-responsive modified-table">
      <!--<table class="table table-bordered table-hover table-font">
          <thead class="table-light" style="cursor: pointer">
          <tr>
            <th @click="sortList('id')">Id
              <font-awesome-icon icon="sort-down" class="icon" v-if="asc"/>
              <font-awesome-icon icon="sort-up" class="icon" v-else/>
            </th>
            <th @click="sortList('fullName')">
              <div>
                Full Name
                <font-awesome-icon icon="sort-down" class="icon" v-if="asc"/>
                <font-awesome-icon icon="sort-up" class="icon" v-else/>
              </div>
            </th>
            <th @click="sortList('email')">Email</th>
            <th @click="sortList('departmentName')">Department Name</th>
            <th @click="sortList('systemName')">System Name</th>
            <th @click="sortList('segmentName')">Segment Name</th>
            <th>RefreshToken</th>
            <th @click="sortList('createdAt')">CreateAt</th>
            <th @click="sortList('lastLoginDT')">Last Login DT</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(user,index) in searchUsers" :key="index">
            <td>{{user.id}}</td>
            <td>{{user.fullName}}</td>
            <td>{{user.email}}</td>
            <td>{{user.departmentName}}</td>
            <td>{{user.systemName}}</td>
            <td>{{user.segmentName}}</td>
            <td>{{user.refreshToken}}</td>
            <td>{{user.createdAt | shortFormatDateNumeric}}</td>
            <td>{{user.lastLoginDT |shortFormatDateNumeric}}</td>
          </tr>
          <div class="col-12" v-if="searchUsers.length < 1">
            <p >No results found!</p>
          </div>
          </tbody>
        </table>-->
        <dynamic-table :gridconfig="gridconfig" :gridData="userList" :gridMainConfig="gridMainConfig"></dynamic-table>
      </div>
      <!--<div v-if="userList.length > 0" style="float: right">
        <div class="card-footer pb-0 pt-3">
          <jw-pagination :items="userList"  @changePage="onChangePage" :styles="customStyles" ></jw-pagination>
        </div>
      </div>-->
      <div v-else>
        <LoadingButton/>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {loadingMixin} from "../../utils/mixins";
import LoadingButton from "../../components/ui/LoadingButton";
import DynamicTable from "../../components/ui/DynamicTable";
const {mapActions, mapState} = createNamespacedHelpers('users');

const customStyles = {
  a:{
    color:'#110e70'
  },
};
export default {
  name: "UserList",
  mixins: [loadingMixin],
  components: {
    LoadingButton,
    DynamicTable
  },
  data() {
    return {
      searchText: "",
      sortedbyASC: true,
      asc:true,
      searchUsers : [],
      customStyles,
      gridconfig:[
        {fieldName :'id',fieldTitle:'Id' , type : 'text', icon:'', format:''},
        {fieldName :'fullName',fieldTitle:'Full Name' , type : 'text',icon:'' , format:''},
        {fieldName :'email',fieldTitle:'Email' , type : 'text',icon:'' , format:''},
        {fieldName :'departmentName',fieldTitle:'Department Name' , type : 'text' ,icon:'' , format:''},
        {fieldName :'systemName',fieldTitle:'System Name' , type : 'text' ,icon:'' , format:''},
        {fieldName :'segmentName',fieldTitle:'Segment Name' , type : 'text' ,icon:'' , format:''},
        {fieldName :'refreshToken',fieldTitle:'RefreshToken' , type : 'text' ,icon:'' , format:''},
        {fieldName :'createdAt',fieldTitle:'CreateAt' , type : 'datetime',icon:'' , format:'shortFormatDateNumeric'},
        {fieldName :'lastLoginDT',fieldTitle:'Last Login DT' , type : 'datetime' , icon:'' ,format:'shortFormatDateNumeric'}

      ],
      gridMainConfig: {
        pagination:false,sorting:true
      },
    }
  },
  methods: {
    ...mapActions(["getUsers"]),
    async goToUserDetails(value, name) {
      this.$router.push({
        name: 'UserDetails',
        params: {selectedUserId: parseInt(value), selectedUserName: name}
      });
    },
    onChangePage(searchUsers) {
      this.searchUsers = searchUsers;
    },
    filteredUser(){
      this.searchUsers = this.userList.filter((user) => {
            return  user.fullName.toUpperCase().match(this.searchText.toUpperCase())
                || user.email.toUpperCase().match(this.searchText.toUpperCase())
                || user.departmentName.toUpperCase().match(this.searchText.toUpperCase());
          },
      );
    },
    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.userList.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
        this.asc = false
      } else {
        this.userList.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
        this.asc = true
      }
    },
  },
  computed: {
    ...mapState(["userList"]),
  },
  async created() {
    this.showLoading();
    try {

      await this.getUsers();
      console.log(this.searchUsers);
      console.log(this.userList);
    }finally {
      this.hideLoading();
    }
  },
}
</script>

<style>
.active>.page-link, .page-link.active {
  background-color: #56759c !important;
  color: #f3f3f3 !important;
}
.disabled>.page-link, .page-link.disabled {
  color: #6c757d !important;
}
.hide-text {
  -webkit-text-security: disc;
}
.form-control:focus {
  border-color:#3c688f;
  box-shadow: 0 0 0 1px #3c688f;
}
.table-font{
  font-size: 13px;
  font-family: Helvetica, Arial;
  border-left: 1px solid #dfe0e1;
  border-right: 1px solid #dfe0e1;
}
.page-link:focus {
  background-color: #56759c;
  color: #f3f3f3;
}
.test:focus{
  background-color: unset !important;
  color: #0d6efd !important;
}
button.page-link {
  display: inline-block;
}
</style>